import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { AuthProvider } from "@/context/AuthContext";
import { ThemeProvider, useTheme } from "@/context/ThemeContext";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Leaderboard from "@/pages/Leaderboard";
import CompanyProfile from "@/pages/CompanyProfile";
import AddBusiness from "@/pages/AddBusiness";
import ClaimBusiness from "@/pages/ClaimBusiness";
import BoostConfirm from "@/pages/BoostConfirm";
import AuthPage from "@/pages/AuthPage";
import Admin from "@/pages/Admin";
import TopSpot from "@/pages/TopSpot";
import Discover from "@/pages/Discover";
import DiscoverAdmin from "@/pages/DiscoverAdmin";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import RefundPolicy from "@/pages/RefundPolicy";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import ChangePassword from "@/pages/ChangePassword";
import Pricing from "@/pages/Pricing";

// Module-level ref so ScrollToTop can call lenis.scrollTo instead of window.scrollTo
let _lenis = null;

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (_lenis) {
      _lenis.scrollTo(0, { immediate: true });
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname]);
  return null;
}

function Shell() {
  const { theme } = useTheme();

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    _lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      _lenis = null;
    };
  }, []);

  return (
    <AuthProvider>
      <BrowserRouter>
        <ScrollToTop />
        <div className="App min-h-screen bg-[#050505] text-slate-100">
          <Header />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/leaderboard" element={<Leaderboard />} />
            <Route path="/leaderboard/:regionSlug" element={<Leaderboard />} />
            <Route path="/top-spot" element={<TopSpot />} />
            <Route path="/company/:slug" element={<CompanyProfile />} />
            <Route path="/add-business" element={<AddBusiness />} />
            <Route path="/claim/:slug" element={<ClaimBusiness />} />
            <Route path="/boost/confirm" element={<BoostConfirm />} />
            <Route path="/auth" element={<AuthPage />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/discover" element={<Discover />} />
            <Route path="/discover-admin" element={<DiscoverAdmin />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/refund-policy" element={<RefundPolicy />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/change-password" element={<ChangePassword />} />
            <Route path="/pricing" element={<Pricing />} />
          </Routes>
          <Footer />
        </div>
        <Toaster position="top-center" theme={theme} />
      </BrowserRouter>
    </AuthProvider>
  );
}

function App() {
  return (
    <ThemeProvider>
      <Shell />
    </ThemeProvider>
  );
}

export default App;
